module.exports = __webpack_public_path__ + "media/insights/earth_icon-8ec32e8e.png";